module.exports = __webpack_public_path__ + "static/media/Lucky New Year.ff88e1a2.png";